export default "__VITE_ASSET__C9QS0iDE__"